// extracted by mini-css-extract-plugin
export default {"step-number":"configurator-web-step-number"};